import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Activity, Clock, Flame, Scale } from 'lucide-react';
const reasons = [{
  title: 'Chronic Cardio',
  description: 'Spikes your cortisol, telling your body to hold onto "protective" belly fat for dear life.',
  icon: Activity
}, {
  title: 'Extreme Fasting',
  description: 'Stresses your nervous system, leading to the dreaded 3 AM "wired and tired" wake-up call.',
  icon: Clock
}, {
  title: 'Low-Carb "Keto"',
  description: 'Often crashes your thyroid and progesterone, leaving you bloated and brain-fogged.',
  icon: Flame
}, {
  title: 'Counting Calories',
  description: 'Ignores the "Inflammatory Flood" that causes your scale to jump 3 lbs overnight for no reason.',
  icon: Scale
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export const WhyDidntWork = () => {
  return <section className="py-24 bg-wellness-cream-dark" data-id="element-158">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-160">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-161">
            Why What You Tried{' '}
            <span className="italic text-wellness-gold-dark" data-id="element-162">Didn't Work</span>
          </h2>
          <div className="w-16 h-[1px] bg-wellness-sage mx-auto" data-id="element-163"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-2 gap-8" data-id="element-164">
          {reasons.map((reason, index) => <motion.div key={index} variants={itemVariants} className="bg-wellness-cream p-8 md:p-10 rounded-2xl border border-wellness-sage/20 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-165">
              <div className="w-12 h-12 rounded-full bg-wellness-sage/10 flex items-center justify-center mb-6 text-wellness-forest" data-id="element-166">
                <reason.icon strokeWidth={1.5} size={24} data-id="element-167" />
              </div>
              <h3 className="text-2xl mb-3" data-id="element-168">{reason.title}</h3>
              <p className="font-sans font-light text-wellness-forest/80 leading-relaxed" data-id="element-169">
                {reason.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};